import { clientApiHostName } from "../../endpoint";
import { defaultHeaders } from "../../headers";

export const create = async client => {
  try {
    const result = await fetch(`${clientApiHostName}/register`, {
      method: "POST",
      headers: {
        ...defaultHeaders,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      },
      body: JSON.stringify(client)
    });
    return {
      hasSuccess: result.status === 200,
      data: await result.json()
    };
  } catch (err) {
    return {
      hasSuccess: false,
      data: err.message
    };
  }
};
